import React, { useState } from "react";
import constants from "../../../constant";
const axios = require("axios");

export default function AdminSupportform() {
    const [subject, setSubject] = useState("");
    const [description, setDescription] = useState("");
    return (
        <div>
            <div className="main-container">
                <div className="min-height-200px">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <div className="title">
                                    <h4>Support</h4>
                                </div>
                                <nav aria-label="breadcrumb" role="navigation">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a href="/admindashboard">Home</a>
                                        </li>
                                        <li
                                            className="breadcrumb-item active"
                                            aria-current="page"
                                        >
                                            Support
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <div className="page-header">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <form>
                                    <div className="form-group row">
                                        <label className="col-sm-12 col-md-2 col-form-label">
                                            Email
                                        </label>
                                        <div className="col-sm-12 col-md-10">
                                            <input
                                                className="form-control"
                                                defaultValue="shikshakprabandanorg@gmail.com"
                                                type="email"
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-12 col-md-2 col-form-label">
                                            Subject
                                        </label>
                                        <div className="col-sm-12 col-md-10">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Problem/Query"
                                                value={subject}
                                                onChange={(e) =>
                                                    setSubject(e.target.value)
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-12 col-md-2 col-form-label">
                                            Description
                                        </label>
                                        <div className="col-sm-12 col-md-10">
                                            <textarea
                                                className="form-control"
                                                placeholder="Problem/Query Description"
                                                value={description}
                                                onChange={(e) =>
                                                    setDescription(
                                                        e.target.value
                                                    )
                                                }
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-12 col-md-2 col-form-label"></label>
                                        <div className="col-sm-12 col-md-10">
                                            <input
                                                className="btn btn-primary"
                                                type="submit"
                                                defaultValue="Submit"
                                                onClick={async (e) => {
                                                    e.preventDefault();
                                                    const result = await axios({
                                                        method: "POST",
                                                        url: `${constants.backendUrl}/adminSupport`,
                                                        headers: {
                                                            "Content-Type":
                                                                "application/json",
                                                        },
                                                        data: {
                                                            subject: subject,
                                                            description:
                                                                description,
                                                            email: localStorage.getItem(
                                                                "email"
                                                            ),
                                                        },
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
